<template>
  <v-dialog v-model="show" max-width="75%">
    <v-card>
      <v-card-title class="primary">
        <span class="headline white--text">{{ titleForm }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="6" sm="6" md="6">
              <v-text-field
                label="Medication"
                v-model="newMedication"
                readonly
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <v-text-field
                label="Amount Administered"
                v-model="newAmountAdministered"
                :readonly="!canUpdate"
                :disabled="!canUpdate"
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <v-select
                :items="adminTime"
                label="Scheduled Admin Time"
                v-model="newAdminTime"
                readonly
                disabled
              ></v-select>
            </v-col>
            <v-col class="d-flex" cols="12" sm="6">
              <v-text-field
                v-model="newNotes"
                label="Notes"
                
              ></v-text-field>
            </v-col>

            <v-col class="d-flex" cols="12" sm="6">
              <v-text-field
                class="update-icon"
                v-model="newSignature"
                label="Signature"
                :readonly="basicStaff"
                :disabled="basicStaff"
                clearable
              >
                <template slot="append" v-if="canUpdate">
                  <v-btn icon @click="onUpdateSignature()">
                    <v-icon>mdi-pencil-box-outline</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
            </v-col>

            <v-col class="d-flex" cols="12" sm="6">
              <v-text-field
                class="update-icon"
                v-model="newVerifiedBy"
                label="Verified By"
                :readonly="isVerifiedByBlank ? false : basicStaff"
                :disabled="isVerifiedByBlank ? false : basicStaff"
                @click="onVerifiedBySignature"
                clearable
              >
                <template slot="append" v-if="canVerify">
                  <v-btn icon @click="onVerifiedBySignature()">
                    <v-icon>mdi-pencil-box-outline</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" v-if="!basicStaff">
              <h5 class="red--text">If you're fixing a signature on behalf of another staff, select the staff that signed the medication for reporting purposes.</h5>

            </v-col>
            <v-col class="d-flex" cols="12" sm="6" v-if="!basicStaff">
              <v-autocomplete
                label="Select Staff that Signed Med"
                :items="users"
                item-text="Name"
                item-value="_id"
                v-model="StaffID"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <v-menu offset-y max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="newDate"
                    label="Date"
                    v-on="on"
                    prepend-icon="event"
                    :disabled="!canUpdate"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="newDate"
                  show-current="newDate"
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <v-text-field
                v-model="actualTime"
                label="Actual Admin Time"
                :disabled="!canUpdate"
              ></v-text-field>
              <!-- <v-select
                :items="adminTime"
                label="Actual Admin Time"
                v-model="newActualAdminTime"
              ></v-select> -->

              <!-- <v-dialog
                ref="dialog"
                v-model="actualAdminTimeDialog"
                :return-value.sync="newActualAdminTime"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="actualTime"
                    label="Actual Admin Time"
                    prepend-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="actualAdminTimeDialog"
                  v-model="newActualAdminTime"
                  full-width
                  format="ampm"
                  @change="getActualTime"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="actualAdminTimeDialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.dialog.save(newActualAdminTime)"
                  >
                    OK
                  </v-btn>
                </v-time-picker>
              </v-dialog> -->
            </v-col>
            <v-col cols="6">
              <v-select
                clearable
                v-model="newException"
                label="Exception"
                :items="exceptions"
                :disabled="!canUpdate"
              ></v-select>
            </v-col>
          </v-row>

          <v-row v-if="showVitals">
            <v-col cols="12" sm="12" md="12">
              <strong class="text--darken-4">Vitals</strong>
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="3">
                <template v-for="(value, key, i) in vitals" >
                <v-text-field
                  :key="i"
                  :label="key"
                  v-model="vitalsRequired[key]"
                ></v-text-field>
                </template>
            </v-col>
          </v-row>

          <v-row v-if="showPRN">
            <v-col cols="12" sm="12" md="12">
              <strong class="text--darken-4">Follow Up PRN</strong>
              <v-divider></v-divider>
            </v-col>
            <v-col class="d-flex" cols="12" sm="6">
              Is Effective?
              <v-sheet class="pa-5">
                <v-switch
                  v-model="switch1"
                  inset
                  label="YES"
                  @click="isEffective(1)"
                ></v-switch>
                <v-switch
                  v-model="switch2"
                  inset
                  label="NO"
                  @click="isEffective(0)"
                ></v-switch>
              </v-sheet>
            </v-col>
            <v-col class="d-flex" cols="12" sm="6">
              <v-textarea
                v-model="newPRNNote"
                label="Note"
                auto-grow
                outlined
              ></v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- v-if="canUpdate && medCerified" -->

        <div v-if="isShowUpdateBtn && !isAuditorRole">
          <v-btn color="blue darken-1" text @click="onUpdateItem" v-if="canUpdate || canUpdateNote">Update</v-btn>
        </div>
        <v-btn color="blue darken-1" text @click.stop="close"
          >Cancel</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import axios from "axios";
const url = require("../../../client_config/config").url;
import { mapGetters } from "vuex";
import { setUserTz, tz } from "../../../../utils/timezone";

export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    marItemData: {
      type: Object,
    },

    verifiedSignature: {
      type: String,
    },
    isPageHistory: {
      type: Boolean,
      default: true,
    },
    unsigned: {
      type: Boolean,
    },
    isShowUpdateBtn: {
      type: Boolean,
      default: true
    },
    isAuditorRole: {
      type: Boolean,
      default: false
    }

  },
  data() {
    return {
      switch1: false,
      switch2: false,
      newPRNNote: "",
      newPRNIsEffective: "",
      showPRN: false,
      showVitals: false,
      newMedication: "",
      newMedicationId: "",
      newAmountAdministered: "",
      newAdminTime: "",
      exceptions: [
        "Absent",
        "Dropped",
        "Medication Unavailable",
        "Spit Out",
        "Meds on Hold",
        "Refused",
        "Low Vitals",
        "High Vitals",
        "Other",
      ],
      newNotes: "",
      newException: "",
      newSignature: "",
      newSignatureData: "",
      newSignatureDataAdd: "",
      newVerifiedBy: "",
      newDate: "",
      newActualAdminTime: "",
      directCareStaff: false,
      adminTime: [
        "12:00am",
        "1:00am",
        "2:00am",
        "3:00am",
        "4:00am",
        "5:00am",
        "6:00am",
        "7:00am",
        "8:00am",
        "9:00am",
        "10:00am",
        "11:00am",
        "12:00pm",
        "1:00pm",
        "2:00pm",
        "3:00pm",
        "4:00pm",
        "5:00pm",
        "6:00pm",
        "7:00pm",
        "8:00pm",
        "9:00pm",
        "10:00pm",
        "11:00pm",
        "PRN",
      ],
      msg: false,
      text: "",
      color: "",
      titleForm: "New Inventory Item",
      editMAR: false,
      marID: null,
      clientID: this.$route.params.clientID,
      menu2: false,
      actualAdminTimeDialog: false,
      actualTime: "",
      vitalsRequired: {},
      vitals: [],
      userRole: localStorage.getItem("userRole"),
      officeAdminRole: ["Administration", "Program Coordinator", "Compliance Manager", "Human Resources", "Human Resources Assistant", "Client Services Manager", "Medical Manager", "Executive Director", "Program Manager"],
      basicStaffRole: ["Direct Care Staff", "Assistant Manager", "Shift Lead", "House Manager" ],
      userID: localStorage.getItem("userID"),
      userState: localStorage.getItem('userState'),
      users: [],
      StaffID: "",
    };
  },
  computed: {
    ...mapGetters("timezones", ["getUserTimezone", "getDefaultTz"]),

    userTimezone() {
      const data = {
        userTimezone: this.getUserTimezone,
        defaultTz: this.getDefaultTz,
      };
      return setUserTz(data);
    },

    show: {
      get() {
        return this.dialog;
      },
      set(val) {
        if (!val) {
          this.$emit("close");
          this.clear();
        }
      },
    },

    isVerifiedByBlank() {
      return this.newVerifiedBy.trim() === '';
    },

    canVerify(){
      if(!this.basicStaffRole.includes(this.userRole) && this.medCertified){
        return true
      }
      return false
    },

    basicStaff() {
      if(this.basicStaffRole.includes(this.userRole)){
        return true
      }
      return false
    },

    canUpdate(){
      if(this.officeAdminRole.includes(this.userRole) && this.medCertified){
        return true
      }else if(this.unsigned){
        return true
      }
      return false;
    },

    canUpdateNote() {
      if(this.basicStaffRole.includes(this.userRole) || (this.officeAdminRole.includes(this.userRole))){
        return true
      }
      return false
    },
    
    medCertified(){
      return this.$store.state.users.user.MedCertified || false
    },

  },
  created() {
    this.getEmployees()
  },
  methods: {
    onViewItem(item) {
      const { Medication } = item;
      this.titleForm = "Viewing MAR";
      this.newMAR = false;
      this.newMedication = Medication?.Medication || "";
      this.newMedicationId = Medication?._id || "";
      this.newAmountAdministered = item.AmountAdministered;
      this.newAdminTime = item.AdminTime;
      this.newNotes = item.Notes;
      this.newException = item.Exception;
      this.newSignature = item.Signature;
      this.newVerifiedBy = item.VerifiedBy;
      this.newDate = tz(item.Date, this.userTimezone).format("YYYY-MM-DD");
      this.actualTime = item?.ActualAdminTime || "";
      this.marID = item._id;
      this.showPRN = false;
      this.showVitals = false;
      this.StaffID = item.StaffID
      this.getVitals(item)

      if (item.AdminTime == "PRN") {
        if (item.FollowUpPRN[0].IsNotify) {
          this.showPRN = true;
          if (item.FollowUpPRN[0].IsEffective == true) {
            this.switch1 = true;
          }
          if (item.FollowUpPRN[0].IsEffective == false) {
            this.switch2 = true;
          }
          this.newPRNNote = item.FollowUpPRN[0].Note;
        }
      }
    },
    onUpdateItem() {
      let staff = '';
      if (!this.basicStaff) {
        staff = this.StaffID;
      } else if (this.basicStaff) {
        staff = this.userID;
      }
      let data = (() => {
        let props = {
          ClientID: this.clientID,
          MedicationId: this.newMedicationId,
          MedicationName: this.newMedication,
          AmountAdministered: this.newAmountAdministered,
          AdminTime: this.newAdminTime,
          Notes: this.newNotes,
          Exception: this.newException || "",
          Signature: this.newSignature || "",
          VerifiedBy: this.newVerifiedBy || "",
          Date: this.newDate,
          ActualAdminTime: this.actualTime,
          PRNNote: this.newPRNNote,
          PRNIsEffective: this.newPRNIsEffective,
          UrlNotification: this.$router.history.current.path,
          VitalsRequired: [this.vitalsRequired],
          FollowUpPRN: [ { IsEffective: this.newPRNIsEffective, Note: this.newPRNNote, IsNotify: true } ],
          Medication: {
            _id: this.newMedicationId,
            Medication: this.newMedication
          },
          StaffID: staff
        };
        return props;
      })();

      this.$emit("updateMAR", data, this.marID, this.unsigned);
      this.vitals = []
    },

    onVerifiedBySignature() {
      this.$emit("verifiedBySignature");
      this.$nextTick(() => {
        this.newVerifiedBy = this.verifiedSignature;
      });
    },

    onUpdateSignature() {
      this.$emit("verifiedBySignature");
      this.$nextTick(() => {
        this.newSignature = this.verifiedSignature;
      });
    },

    clear() {
      this.newMedicationId = "";
      this.newMedication = "";
      this.newAmountAdministered = "";
      this.newNotes = "";
      this.newException = "";
      this.newSignature = "";
      this.newVerifiedBy = "";
      this.newActualAdminTime = "";
      this.actualTime = "";
      (this.newPRNIsEffective = ""), (this.switch1 = false);
      this.switch2 = false;
    },

    getActualTime() {
      this.actualTime = moment(this.newActualAdminTime, ["h:mm a"]).format(
        "hh:mma"
      );
    },

    isEffective(val) {
      console.log(val);
      if (val === 1) {
        this.switch1 = true;
        this.switch2 = false;
        this.newPRNIsEffective = true;
      }
      if (val === 0) {
        this.switch2 = true;
        this.switch1 = false;
        this.newPRNIsEffective = false;
      }
    },

    getVitals(item) {
      if (item.VitalsRequired.length != 0) {
        let vitalLength = Object.keys(item.VitalsRequired[0]).length;
        let vitalType = typeof item.VitalsRequired[0];
        if (vitalType === "object") {
          if (vitalLength != 0)
            return (
              (this.showVitals = true),
              (this.vitals = item.VitalsRequired[0]),
              (this.vitalsRequired = this.vitals)
            );
          this.showVitals = false;
        }

        if (vitalType === "string") {
          if (vitalLength != 0)
            return (
              (this.showVitals = true),
              (this.vitals = item.VitalsRequired.reduce(
                (acc, val) => ({ ...acc, [val]: "" }),
                {}
              ))
            );
          this.showVitals = false;
        }
      }
    },

    getEmployees() {
      axios.get(`${url}/employees/staff/${this.userState}`).then((res => {
        this.users = res.data.employees
      }))
    },

    close(){
      this.show = false;
      this.vitals = [];
      this.vitalsRequired = {}
    }
  },
};
</script>

<style scoped>
.update-icon >>> .mdi-pencil-box-outline {
  color: #5a99f6;
}
</style>
